// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e86addb3","455":"defc12d5","977":"7a3b6bc4"}[chunkId] + ".chunk.js";
};